export type DependencySelection = { predecessor_ids: string[]; successor_ids: string[] };

/** Adding predecessors → new task → successors cycles if a successor can already reach a predecessor. */
export function createsDependencyCycle(edges: { predecessor_id: string; successor_id: string }[], selection: DependencySelection): boolean {
  const predecessors = new Set(selection.predecessor_ids);
  const next = new Map<string, string[]>();
  for (const edge of edges) next.set(edge.predecessor_id, [...(next.get(edge.predecessor_id) ?? []), edge.successor_id]);
  const pending = [...selection.successor_ids], visited = new Set<string>();
  while (pending.length) {
    const id = pending.pop()!;
    if (predecessors.has(id)) return true;
    if (visited.has(id)) continue;
    visited.add(id);
    pending.push(...(next.get(id) ?? []));
  }
  return false;
}
